import { z } from 'zod';
import { nameSchema, objectIdSchema, quantitySchema } from '../../validation';
import { amountSchema } from '../../common';

/**
 * the type of the item in the invoice that the user is going to pay for.
 *
 * We can use this structure to expand to other services in the future and charge users.
 *
 * For now, all charges will be based `order_vehicle`.
 */
export const invoiceItemTypeSchema = z.enum(['order_vehicle', 'other']);
export type InvoiceItemType = z.infer<typeof invoiceItemTypeSchema>;

export const invoiceItemSchema = z.object({
  type: invoiceItemTypeSchema,
  /** custom description of the item
   *
   * For example, Multi order trucks
   */
  description: nameSchema,
  /** if orders ... it will be number of orders */
  quantity: quantitySchema,

  /** the total amount of the item */
  amount: amountSchema,

  /**
   * the Order contract leg this invoice item is capturing. Points at
   * `Order.contracts[i].contractId`. Used by
   * `InvoiceService.captureOrderLeg` to reconcile invoice items with the
   * contract legs of chained orders so each leg generates its own
   * invoice without Hero inserting itself between parties.
   *
   * Optional — legacy invoice items pre-dating the chain model do not
   * carry this. Phase 6 backfill best-effort populates it from
   * existing `Invoice.items[].note` / `quantity` heuristics where
   * possible.
   *
   * Expected index (operator-applied): `{ 'items.contractId': 1 }`.
   */
  contractId: objectIdSchema.optional(),

  /** any additional note */
  note: nameSchema.optional(),
});
export type InvoiceItem = z.infer<typeof invoiceItemSchema>;
